import { LitElement, html, unsafeCSS, CSSResultGroup } from "lit";
import { customElement, property } from "lit/decorators.js";
import informationBlockStyles from "../../styles/information-block.css?inline";
import { Icon } from "../Icon";

// Import nécessaire pour enregistrer le composant Icon
Icon;

@customElement("apidae-detail-view-information-block-disclaimer")
export class InformationBlockDisclaimer extends LitElement {
  static styles: CSSResultGroup = unsafeCSS(informationBlockStyles);

  @property({ type: String })
  text: string = "";

  @property({ type: String })
  logo: string = "";

  @property({ type: String })
  color: string = "primary10";

  render() {
    return html`
      <div
        class="information-block-disclaimer information-block-disclaimer--${this
          .color}"
      >
        ${this.logo
          ? html`
              <apidae-icon
                name="${this.logo}"
                size="24"
                color="currentColor"
                class="information-block-disclaimer-icon"
              ></apidae-icon>
            `
          : ""}
        <div class="information-block-disclaimer-text">${this.text}</div>
      </div>
    `;
  }
}

declare global {
  interface HTMLElementTagNameMap {
    "apidae-detail-view-information-block-disclaimer": InformationBlockDisclaimer;
  }
}
